import styles from './media-grid.module.css';

const MediaGrid = ({ items }) => {
  return (
    <div className={styles.root}>
      {items.map(({ id, text, href, icon, name, width }) => (
        <a className={styles.item} style={{ flexBasis: width }} href={href} target="_blank" rel="noreferrer" key={id}>
          <div className={styles.logo}>
            <img src={icon} className={styles.logoIcon} alt={name} />
          </div>
          <div className={styles.description}>{text}</div>
        </a>
      ))}
    </div>
  );
};

export default MediaGrid;
